import type { GanttLayout } from "@/ds";

/**
 * Medidas dos Gantts por Obra (Obras e Local por Obra), sobre o `compact` do DS: o mês do mobile tem ~43,7px
 * (Figma: Carga de Trabalho / Obra, 7824-66792), menos que o do preset.
 */
export const OBRAS_LAYOUT: Partial<GanttLayout> = { monthWidthMobileRem: 2.729 };

/** Linha fina da etapa Obra: a linha fica a 1,625 do topo da linha da tabela, ou a 2,875 quando está sozinha numa linha alta (mobile). */
export function obraLineLayout(tall = false): Partial<GanttLayout> {
  return { ...OBRAS_LAYOUT, rowPaddingRem: tall ? 2.875 : 1.625 };
}

/** Pílula da alocação (altura 18): abaixo da linha da obra (a 2,25 do topo) ou, sem ela, mais acima (a 1,25). */
export function obraPillLayout(hasLine: boolean): Partial<GanttLayout> {
  return { ...OBRAS_LAYOUT, barHeightRem: 1.125, rowPaddingRem: hasLine ? 2.25 : 1.25 };
}

/** Largura (rem) de uma linha com `width` % do eixo de `months` meses de `monthWidthRem` cada. */
export function lineWidthRem(width: number, months: number, monthWidthRem: number): number {
  return (width / 100) * months * monthWidthRem;
}
